import React from 'react';

const BlueHeader = props => {
  const {
    children,
    className,
    labelLocale,
  } = props;
  return (
    <div className={"blue_header" + (className ? (" " + className) : "")}>
      {labelLocale || children}
    </div>
  );
};

export default BlueHeader;



// WEBPACK FOOTER //
// ./source/client/components/common/inputs/blueHeader.jsx